/* KASHEER — product gallery (sections/main-product.liquid)

   Phones and tablets: a swipe carousel that loops (after the last photo the
   first comes round again, and back from the first to the last). A simple
   number on the photo ("01", "02" …) rolls to the next as you swipe. An
   optional hairline ([data-gallery-progress]) can follow the finger.
   Desktop: the photos are stacked and nothing here runs.

   The loop works with one copy of the last photo before the first and one
   copy of the first after the last. Landing on a copy, the track jumps to
   the real photo once the swipe has settled; the two look identical, so the
   jump cannot be seen. */
(function () {
  'use strict';

  var SETTLE_MS = 140;
  var ROLL_MS = 500;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }

  function forEach(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  // A copy of a slide for the loop: hidden from screen readers, never the
  // page's main image, and loaded lazily.
  function cloneSlide(slide) {
    var clone = slide.cloneNode(true);
    clone.removeAttribute('data-gallery-slide');
    clone.classList.add('kasheer-pdp-gallery__slide--clone');
    clone.setAttribute('aria-hidden', 'true');
    forEach(clone.querySelectorAll('img'), function (img) {
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('fetchpriority');
      img.setAttribute('alt', '');
    });
    return clone;
  }

  // The number rolls: the old one slides out, the new one slides in from the
  // side it is coming from (below when moving forward, above when going back).
  function rollNumber(box, value, forward) {
    if (!box) return;
    var current = box.querySelector('span:not(.is-leaving)');
    if (current && current.textContent === value) return;
    forEach(box.querySelectorAll('.is-leaving'), function (old) { old.remove(); });
    var incoming = document.createElement('span');
    incoming.textContent = value;
    if (reduceMotion || !current) {
      box.textContent = '';
      box.appendChild(incoming);
      return;
    }
    incoming.className = forward ? 'is-below' : 'is-above';
    box.appendChild(incoming);
    box.getBoundingClientRect(); // commit the start position before moving
    current.className = forward ? 'is-leaving is-above' : 'is-leaving is-below';
    incoming.className = '';
    window.setTimeout(function () {
      if (current.parentNode) current.remove();
    }, ROLL_MS);
  }

  function isCarousel(state) {
    return window.getComputedStyle(state.track).overflowX !== 'visible';
  }

  function slideWidth(state) {
    return state.track.clientWidth || 1;
  }

  // Position in photos: 0 = first real photo, -1 = the copy of the last one
  // before it, count = the copy of the first one after the last.
  function readPosition(state) {
    return state.track.scrollLeft / slideWidth(state) - 1;
  }

  function jumpTo(state, index) {
    if (!isCarousel(state)) return;
    state.track.scrollLeft = (index + 1) * slideWidth(state);
    state.rounded = index;
  }

  // The dark segment follows the finger; across the wrap it slides back
  // over the whole hairline, so the line reads as one loop.
  function updateBar(state, position) {
    if (!state.bar) return;
    var last = state.count - 1;
    var place = position;
    if (position < 0) place = last * Math.min(1, -position);
    else if (position > last) place = last * Math.max(0, 1 - (position - last));
    state.bar.style.transform = 'translate3d(' + (place * 100) + '%, 0, 0)';
  }

  function render(state, forward) {
    rollNumber(state.now, pad(state.index + 1), forward);
    if (state.spoken) {
      var template = state.spoken.getAttribute('data-counter-template') || '[index] / [count]';
      state.spoken.textContent = template
        .replace('[index]', String(state.index + 1))
        .replace('[count]', String(state.count));
    }
    state.gallery.setAttribute('data-gallery-index', String(state.index));
  }

  // Once a swipe has come to rest on a copy, move to the real photo.
  function settle(state) {
    window.clearTimeout(state.timer);
    if (!isCarousel(state)) return;
    var rounded = Math.round(readPosition(state));
    if (rounded < 0) jumpTo(state, state.count - 1);
    else if (rounded > state.count - 1) jumpTo(state, 0);
  }

  function onScroll(state) {
    if (state.ticking) return;
    state.ticking = true;
    window.requestAnimationFrame(function () {
      state.ticking = false;
      var position = readPosition(state);
      updateBar(state, position);
      var rounded = Math.round(position);
      if (rounded !== state.rounded) {
        var forward = rounded > state.rounded;
        state.rounded = rounded;
        var index = ((rounded % state.count) + state.count) % state.count;
        if (index !== state.index) {
          state.index = index;
          render(state, forward);
        }
      }
      window.clearTimeout(state.timer);
      state.timer = window.setTimeout(function () { settle(state); }, SETTLE_MS);
    });
  }

  // Mouse arrows step one photo either way; the loop means they never run out.
  function bindButtons(state) {
    function step(delta) {
      settle(state);
      var target = Math.round(readPosition(state)) + delta;
      state.track.scrollTo({ left: (target + 1) * slideWidth(state), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    var prev = state.gallery.querySelector('[data-gallery-prev]');
    var next = state.gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function initGallery(gallery) {
    if (gallery.dataset.galleryReady === 'true') return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    if (!track || slides.length < 2) return;
    gallery.dataset.galleryReady = 'true';

    var state = {
      gallery: gallery,
      track: track,
      count: slides.length,
      index: 0,
      rounded: 0,
      ticking: false,
      timer: null,
      now: gallery.querySelector('[data-gallery-now]'),
      bar: gallery.querySelector('[data-gallery-progress]'),
      spoken: gallery.querySelector('[data-gallery-counter]')
    };

    // Add the two copies and move to the first photo in the same task, so
    // the copy of the last photo is never painted first.
    track.insertBefore(cloneSlide(slides[slides.length - 1]), slides[0]);
    track.appendChild(cloneSlide(slides[0]));
    jumpTo(state, 0);

    track.addEventListener('scroll', function () { onScroll(state); }, { passive: true });
    track.addEventListener('scrollend', function () { settle(state); });
    window.addEventListener('resize', function () { jumpTo(state, state.index); });
    bindButtons(state);
    updateBar(state, 0);
    render(state, true);
  }

  function initAll(root) {
    forEach((root || document).querySelectorAll('[data-gallery]'), initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
